import { listRewardCategories } from "../../../graphql/queries/listRewardCategories";

export const dropdownQueryRegistry = {
  listRewardCategories,
};
